<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 11:22:06
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container" class="tagContent">
        <div class="page">
            <van-tabs v-model="active" @click="tagClick" swipeable sticky v-if="show">
                <van-tab v-for="(item, index) in tagList" :key="index" :title="item.tagName"></van-tab>
            </van-tabs>
            <div id="main-container" class="main-container tag-list">
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list v-model="ploading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
                        <div v-if='!isShow'>
                            <div v-for="good in goodsList" :key="good.id" @click="godetail(good)">
                                <goodCommon :good="good"></goodCommon>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
                <!-- 无商品 -->
                <div class="nogood" v-if='isShow'>
                    <img src="../assets/img/myCenter/noList.png" alt="">
                    <p>暂无商品</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import goodCommon from '@/components/common/goodCommon';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    name: 'searchList',
    components: {
        goodCommon
    },
    data() {
        return {
            isShow: false,
            show: false,
            active: '',
            tagList: [],
            pageNum: 1,
            pageSize: 5,
            goodsList: [],
            isLoading: false,
            ploading: false,
            finished: true,
            id: '',
            scrollTop: 0
        };
    },
    esvReady: function() {
        this.id = this.$route.query.id;
        this.active = this.$route.query.index;
        this.ESVStorage.getSavedValue('tagIndex', (data) => {
            this.tagList = data;
        });
        this.initList();
    },
    esvShow() {
        setTimeout(() => {
            document.querySelector('.main-container').scrollTo({ top: this.scrollTop || 0, behavior: 'smooth' });
        }, 0);
    },
    methods: {
        initList() {
            const ths = this;
            ths.getData(ths.id);
        },
        godetail: function(item) {
            const ths = this;
            ths.ESVStorage.putSavedValue('goodsId', item.productId);
            this.scrollTop = document.querySelector('.main-container').scrollTop;
            ths.esvOpenPage({ name: 'OPGoodsdetail', params: { goodsId: item.productId } });
        },
        tagClick(index) {
            this.id = this.tagList[index].id;
            this.pageNum = 1;
            this.goodsList = [];
            this.getData(this.id);
        },
        getData(id) {
            const ths = this;
            const params = {
                id: id,
                pageNum: ths.pageNum,
                pageSize: ths.pageSize
            };
            ths.$doRequest(
                {
                    url: '/index/queryProductsBytagId',
                    params: params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.finished = true;
                        ths.ploading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    const total = parseInt(data.result.productBaseInfoList.total);
                    ths.goodsList = ths.pageNum === 1 ? data.result.productBaseInfoList.list : [...ths.goodsList, ...data.result.productBaseInfoList.list];
                    if (ths.goodsList.length < total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }
                    if (ths.goodsList.length === 0) {
                        ths.isShow = true;
                    } else {
                        ths.isShow = false;
                    }
                    ths.show = true;
                }
            );
        },
        // 下拉刷新
        onLoad() {
            this.pageNum++;
            this.initList();
        },
        onRefresh() {
            setTimeout(() => {
                this.pageNum = 1;
                this.initList();
                this.isLoading = false;
            }, 500);
        }
    }
};

</script>
<style lang="scss" scoped>
.nogood {
    text-align:center;
    padding-top:121px;
    background-color: #f3f3f3;
    img {
        width:203px;
    }
    p {
        color:#999;
        padding-top:14px;
        text-align:center;
    }
}
.van-tabs {
    height: auto;
}
.van-pull-refresh {
    padding-bottom: 50px;
}
</style>
